// index.js (patched)
import React, { useState, useEffect, useMemo } from "react";
import {
  Progress,
  Button,
  Radio,
  Col,
  Row,
  Input,
  Select,
  InputNumber,
  message,
  Checkbox,
  Switch,
  DatePicker,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { completeCard } from "../../../../redux/assessmentSlice";
import FormWrapper from "../FormWrapper";
import "../assesment.css";
import { useMediaQuery } from "react-responsive";
import { backBtnTxt, exitBtnTxt, saveAndContinueBtn, submitBtn } from "../../../../../utils/constant";
import { getPersonalFamilyPatient } from "../../../../redux/AssessmentController";
import dayjs from 'dayjs';
import { baseUrl } from "../../../../../utils/envAccess";

const { Option } = Select;

const questions = [
  {
    question: "(Check box and provide number if applicable)",
    title: "Obstetric History",
    type: "checkbox_with_select",
    name: "obstetricHistory",
    options: [
      {
        label: "Pregnancies",
        name: "pregnancies",
        selectName: "pregnancies_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Miscarriages",
        name: "miscarriages",
        selectName: "miscarriages_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Abortions",
        name: "abortions",
        selectName: "abortions_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Living children",
        name: "living_children",
        selectName: "living_children_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Vaginal deliveries",
        name: "vaginal_deliveries",
        selectName: "vaginal_deliveries_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Caesarean",
        name: "caesarean",
        selectName: "caesarean_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Term births",
        name: "term_births",
        selectName: "term_births_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "Premature birth",
        name: "premature_birth",
        selectName: "premature_birth_select",
        selectOptions: Array.from({ length: 30 }, (_, i) => 1 + i),
      },
      {
        label: "N/A",
        name: "obstetricHistory_none",
        selectName: null,
      }
    ],
  },
  {
    question: "Provide number if applicable",
    type: "unit_toggle",
    name: "weight_unit",
    title: "Obstetric History",
    options: ["Metric", "Imperial"],
    subQuestions: [
      {
        question: "Birth weight of smallest baby",
        type: "number_with_unit",
        name: "smallest_baby_weight",
        unit: "kg",
      },
      {
        question: "Birth weight of largest baby",
        type: "number_with_unit",
        name: "largest_baby_weight",
        unit: "kg",
      },
    ],
  },
  {
    question:
      "Did you develop any problems in or after pregnancy, for example, toxemia (high blood pressure), diabetes, post-partum depression, issues with breast feeding, etc.?",
    type: "long_radio",
    title: "Obstetric History",
    name: "pregnancy_problems",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: Please explain",
        type: "text",
        name: "pregnancy_problems_sub",
      },
    ],
  },

  {
    question: "Age at first period",
    title: "Menstrual History",
    type: "select",
    name: "age_of_period",
    options: Array.from({ length: 30 }, (_, i) => 7 + i),
  },
  {
    question: "Date of last menstrual period",
    type: "date",
    title: "Menstrual History",
    name: "date_of_last_period",
  },
  {
    question: "Length of cycle",
    type: "select",
    title: "Menstrual History",
    name: "length_of_cycle",
    options: ["Under 20", ...Array.from({ length: 15 }, (_, i) => (20 + i).toString()), "Above 34"],
  },
  {
    question: "Times between cycles",
    type: "select",
    title: "Menstrual History",
    name: "times_between_of_cycle",
    options: Array.from({ length: 30 }, (_, i) => 10 + i),
  },

  {
    question: "Cramping?",
    type: "radio",
    title: "Menstrual History",
    name: "cramping",
    options: ["Yes", "No"],
  },

  {
    question: "Pain?",
    type: "radio",
    title: "Menstrual History",
    name: "pain",
    options: ["Yes", "No"],
  },
  {
    question:
      "Have you ever had premenstrual problems (bloating, breast tenderness, irritability, etc.)?",
    type: "long_radio",
    name: "premenstrual_problems",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: Please describe",
        type: "text",
        name: "premenstrual_problems_describe",
      },
    ],
  },
  {
    question:
      "Do you have other problems with your periods (heavy, irregular, spotting, skipping, etc.)?",
    type: "long_radio",
    name: "other_premenstrual_problems",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: Please describe",
        type: "text",
        name: "other_hormonal_problems_history",
      },
    ],
  },

  {
    question: "Use of hormonal birth control:",
    type: "radio",
    title: "Menstrual History",
    name: "hormonal_birthcontrol",
    options: ["Birth control pills", "Patch", "Nuva ring", "Other"],
    subQuestions: [
      {
        question: "If yes, please describe:",
        type: "text",
        name: "hormonal_birthcontrol_other",
      },
    ],
  },  
  {
    question: "Any problems with hormonal birth control?",
    type: "long_radio",
    name: "other_hormonal_problems",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: explain",
        type: "text",
        name: "any_hormonal_problems_bc",
      },
    ],
  },
  {
    question: "Have you ever used other hormonal birth control?",
    type: "long_radio",
    name: "used_hormonal_problems",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: explain",
        type: "text",
        name: "used_hormonal_problems_bc",
      },
    ],
  },
  {
    question: "Use of other contraception?",
    type: "long_radio",
    name: "use_of_contraception",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes:",
        type: "radio",
        name: "use_of_contraception_sub",
        options: ["Condoms", "Diaphgram", "IUD", "Partner Vasectomy", "Other"],
      },
    ],
  },
  {
    question: "Are you in menopause?",
    type: "long_radio",
    name: "is_menopause",
    title: "Menstrual History",
    options: ["Yes", "No"],
    subQuestions: [
      {
        question: "If Yes: age at last period",
        type: "select",
        name: "age_at_last_period",
        options: Array.from({ length: 100 }, (_, i) => 40 + i),
      },
    ],
  },
  {
    question: "Was it surgical menopause?",
    type: "long_radio",
    name: "surgical_menopause",
    title: "Menstrual History",
    options: ["Yes", "No", "N/A"],
    subQuestions: [
      {
        question: "If Yes: explain surgery",
        type: "text",
        name: "surgical_menopause_detail",
      },
    ],
  },
  {
    question:
      "Do you currently have symptomatic problems with menopause? (Check all that apply)",
    type: "checkbox",
    title: "Menstrual History",

    name: "symptomatic_problems_menopause_history",
    options: [
      "Hot flashes",
      "Mood swings",
      "Concentation/ memory problems",
      "Headaches",
      "Joint pain",
      "Vaginal dryness",
      "Weight gain",
      "Decreased libido",
      "Loss of control of urine",
      "Palpitations",
      "N/A",
    ],
  },

  {
    question: "Are you on hormone replacement therapy?",
    type: "long_radio",
    name: "hormone_replacement_therapy",
    title: "Menstrual History",

    options: ["Yes", "No"],
    subQuestions: [
      {
        question:
          "If yes, for how long and for what reason (hot flashes, osteoporosis prevention, etc.)?",
        type: "text",
        name: "hormone_replacement_therapy_sub",
      },
    ],
  },
  {
    question: "(Check if applicable)",
    type: "checkbox",
    title: "Other Gynecological Symptoms",
    name: "symptomatic_problems_menopause_other",
    options: [
      "Endometriosis",
      "Infertility",
      "Fibrocystic breasts",
      "Vaginal infection",
      "Fibroids",
      "Ovarian cysts",
      "Pelvic inflammatory disease",
      "Reproductive cancer",
      "Sexually transmitted disease (describe)",
      "N/A"
    ],
  },
  // ... rest unchanged ...
  {
    question: "Other tests/procedures (list type and dates):",
    type: "long_textarea",
    sub: "other_test_procedures",
    name: "other_test_procedures",
  },
];

const PersonalAndFamilyHistory = ({ onComplete }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [unit, setUnit] = useState("Metric");
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const patientPersonalFamilyInfo = useSelector((state) => state.intake?.patientPersonalFamilyInfo);

  const mapPersonalFamilyInfoToAnswers = (info) => {
    const mapped = {};
  
    // Map obstetricHistory
    if (info.obstetricHistory && Array.isArray(info.obstetricHistory)) {
      info.obstetricHistory.forEach((item) => {
        const key = item.name?.toLowerCase().replace(/\s+/g, "_");
        mapped[key] = true;
        mapped[`${key}_select`] = item.level || 0;
      });
    }
  
    // Map weightChild data
    if (!info.weightChild || info.weightChild === null) {
      mapped.weight_unit_na = true;
    } else {
      setUnit(info.weightChild.metricImperialScale ? "Metric" : "Imperial");
      mapped.smallest_baby_weight = info.weightChild.weightSmallest || "";
      mapped.largest_baby_weight = info.weightChild.weightLargest || "";
    
      if (!info.weightChild.metricImperialScale) {
        mapped.smallest_baby_weight = mapped.smallest_baby_weight
          ? (mapped.smallest_baby_weight * 2.20462).toFixed(2)
          : "";
        mapped.largest_baby_weight = mapped.largest_baby_weight
          ? (mapped.largest_baby_weight * 2.20462).toFixed(2)
          : "";
      }
    }
  
    // General fields
    mapped.pregnancy_problems = info.problemsAfterPregnancy ? "Yes" : "No";
    mapped.pregnancy_problems_sub = info.problemsAfterPregnancyExplain || "";
  
    mapped.age_of_period = info.ageStartMenstrual || "";
    mapped.date_of_last_period = info.startDateLastMenstrual || "";
    mapped.length_of_cycle = info.lenghtOfCycle || "";
    mapped.times_between_of_cycle = info.timeBtwCycles || "";
  
    mapped.cramping = info.cramping ? "Yes" : "No";
    mapped.pain = info.painInPeriod ? "Yes" : "No";
  
    mapped.premenstrual_problems = info.everHadPreMenstrualProblems?.yesNo ? "Yes" : "No";
    mapped.premenstrual_problems_describe = info.everHadPreMenstrualProblems?.describe || "";
  
    mapped.other_premenstrual_problems = info.otherMenstrualProblems?.yesNo ? "Yes" : "No";
    mapped.other_hormonal_problems_history = info.otherMenstrualProblems?.describe || "";
  
    // Map hormonal birth control
    if (info.hormonalBirthControlType?.name) {
      // If API returned a known option, select it
      const bcType = info.hormonalBirthControlType.name;

      // If it's one of the defined options, set directly
      if (["Birth control pills", "Patch", "Nuva ring"].includes(bcType)) {
        mapped.hormonal_birthcontrol = bcType;
      }
      // Otherwise fallback to "Other"
      else {
        mapped.hormonal_birthcontrol = "Other";
        mapped.hormonal_birthcontrol_other = bcType;
      }

      // Always set duration
      mapped.hormonal_birthcontrol_duration = info.hormonalBirthControlType.level || "";
    } else {
      mapped.hormonal_birthcontrol = "";
      mapped.hormonal_birthcontrol_other = info.otherHormonalBirthControl || "";
      mapped.hormonal_birthcontrol_duration = "";
    }
    mapped.other_hormonal_problems = info.problemsWithHormonalBirthControl?.yesNo ? "Yes" : "No";
    mapped.any_hormonal_problems_bc = info.problemsWithHormonalBirthControl?.describe || "";
  
    mapped.use_of_contraception = info.useContraception?.yesNo ? "Yes" : "No";

    if (info.useContraception?.describe) {
      const standardOptions = ["Condoms", "Diaphgram", "IUD", "Partner Vasectomy"];
      if (standardOptions.includes(info.useContraception.describe)) {
        mapped.use_of_contraception_sub = info.useContraception.describe;
      } else {
        mapped.use_of_contraception_sub = "Other";
        mapped.use_of_contraception_sub_other = info.useContraception.describe;
      }
    } else {
      mapped.use_of_contraception_sub = "";
      mapped.use_of_contraception_sub_other = "";
    }
    mapped.is_menopause = info.inMenopause?.yesNo ? "Yes" : "No";
    mapped.age_at_last_period = info.inMenopause?.level || "";
  
    mapped.surgical_menopause = info.surgicalMenopause?.yesNo ? "Yes" : "No";
    mapped.surgical_menopause_detail = info.surgicalMenopause?.describe || "";
  
    mapped.symptomatic_problems_menopause_history = info.symptomicProblems || [];
  
    mapped.hormone_replacement_therapy = info.hormonalReplacement?.yesNo ? "Yes" : "No";
    mapped.hormone_replacement_therapy_sub = info.hormonalReplacement?.describe || "";
  
    mapped.symptomatic_problems_menopause_other = info.gynSymptoms || [];
  
    mapped.other_test_procedures = info.otherTest || "";
    console.log("mapped--", mapped);
    return mapped;
  };
  
  useEffect(() => {
    dispatch(getPersonalFamilyPatient());
  }, [dispatch]);

  useEffect(() => {
    if (patientPersonalFamilyInfo && Object.keys(patientPersonalFamilyInfo).length > 0) {
      const mappedAnswers = mapPersonalFamilyInfoToAnswers(patientPersonalFamilyInfo);
      setAnswers(mappedAnswers);
      localStorage.setItem("answers", JSON.stringify(mappedAnswers)); // optional: persist locally
    }
  }, [patientPersonalFamilyInfo]);
  

  useEffect(() => {
    if (!patientPersonalFamilyInfo || Object.keys(patientPersonalFamilyInfo).length === 0) {
      dispatch(getPersonalFamilyPatient());
    }
  }, [dispatch, patientPersonalFamilyInfo]);

  useEffect(() => {
    console.log('patientPersonalFamilyInfo received:', patientPersonalFamilyInfo);
    
    if (patientPersonalFamilyInfo && Object.keys(patientPersonalFamilyInfo).length > 0) {
      const mapped = {};
  
      // Map obstetricHistory
      if (patientPersonalFamilyInfo.obstetricHistory && Array.isArray(patientPersonalFamilyInfo.obstetricHistory)) {
        let allZero = true;
      
        patientPersonalFamilyInfo.obstetricHistory.forEach((item) => {
          const key = item.name.toLowerCase().replace(/\s+/g, '_');
          const level = item.level || 0;
      
          if (level > 0) {
            allZero = false;
            mapped[key] = true;
          }
      
          mapped[`${key}_select`] = level;
        });
      
        // Auto-select "None of the above" if all values are 0
        if (allZero) {
          mapped["obstetricHistory_none"] = true;
        }
      }
      

      // Map weightChild data
      if (patientPersonalFamilyInfo.weightChild) {
        setUnit(patientPersonalFamilyInfo.weightChild.metricImperialScale ? "Metric" : "Imperial");
        mapped.smallest_baby_weight = patientPersonalFamilyInfo.weightChild.weightSmallest || "";
        mapped.largest_baby_weight = patientPersonalFamilyInfo.weightChild.weightLargest || "";

        // If Imperial, convert the weights from kg to lbs
        if (!patientPersonalFamilyInfo.weightChild.metricImperialScale) {
          mapped.smallest_baby_weight = mapped.smallest_baby_weight ? (mapped.smallest_baby_weight * 2.20462).toFixed(2) : "";
          mapped.largest_baby_weight = mapped.largest_baby_weight ? (mapped.largest_baby_weight * 2.20462).toFixed(2) : "";
        }
      }
  
      // General fields
      mapped.pregnancy_problems = patientPersonalFamilyInfo.problemsAfterPregnancy ? "Yes" : "No";
      mapped.pregnancy_problems_sub = patientPersonalFamilyInfo.problemsAfterPregnancyExplain || "";

      // Map menstrual history
      mapped.age_of_period = patientPersonalFamilyInfo.ageStartMenstrual || "";
      mapped.date_of_last_period = patientPersonalFamilyInfo.startDateLastMenstrual || "";
      mapped.length_of_cycle = patientPersonalFamilyInfo.lenghtOfCycle || "";
      mapped.times_between_of_cycle = patientPersonalFamilyInfo.timeBtwCycles || "";
      mapped.cramping = patientPersonalFamilyInfo.cramping ? "Yes" : "No";
      mapped.pain = patientPersonalFamilyInfo.painInPeriod ? "Yes" : "No";

      // Map premenstrual problems
      mapped.premenstrual_problems = patientPersonalFamilyInfo.everHadPreMenstrualProblems?.yesNo ? "Yes" : "No";
      mapped.premenstrual_problems_describe = patientPersonalFamilyInfo.everHadPreMenstrualProblems?.describe || "";

      // Map other menstrual problems
      mapped.other_premenstrual_problems = patientPersonalFamilyInfo.otherMenstrualProblems?.yesNo ? "Yes" : "No";
      mapped.other_hormonal_problems_history = patientPersonalFamilyInfo.otherMenstrualProblems?.describe || "";

      // Map hormonal birth control
      // mapped.hormonal_birthcontrol = patientPersonalFamilyInfo.hormonalBirthControlType?.name ? "Yes" : "No";
      // mapped.hormonal_birthcontrol_often = patientPersonalFamilyInfo.hormonalBirthControlType?.level || "";
      // mapped.hormonal_birthcontrol_long = ""; // Not provided in API

      // Map hormonal birth control problems
      mapped.other_hormonal_problems = patientPersonalFamilyInfo.problemsWithHormonalBirthControl?.yesNo ? "Yes" : "No";
      mapped.any_hormonal_problems_bc = patientPersonalFamilyInfo.problemsWithHormonalBirthControl?.describe || "";

      // Map contraception
      mapped.use_of_contraception = patientPersonalFamilyInfo.useContraception?.yesNo ? "Yes" : "No";

      if (patientPersonalFamilyInfo.useContraception?.describe) {
        const standardOptions = ["Condoms", "Diaphgram", "IUD", "Partner Vasectomy"];
        if (standardOptions.includes(patientPersonalFamilyInfo.useContraception.describe)) {
          mapped.use_of_contraception_sub = patientPersonalFamilyInfo.useContraception.describe;
        } else {
          mapped.use_of_contraception_sub = "Other";
          mapped.use_of_contraception_sub_other = patientPersonalFamilyInfo.useContraception.describe;
        }
      } else {
        mapped.use_of_contraception_sub = "";
        mapped.use_of_contraception_sub_other = "";
      }

      // Map menopause
      mapped.is_menopause = patientPersonalFamilyInfo.inMenopause?.yesNo ? "Yes" : "No";
      mapped.age_at_last_period = patientPersonalFamilyInfo.inMenopause?.level || "";

      // Map surgical menopause
      mapped.surgical_menopause = patientPersonalFamilyInfo.surgicalMenopause?.yesNo ? "Yes" : "No";
      mapped.surgical_menopause_detail = patientPersonalFamilyInfo.surgicalMenopause?.describe || "";

      // Map symptomatic problems
      mapped.symptomatic_problems_menopause_history = patientPersonalFamilyInfo.symptomicProblems || [];

      // Map hormone replacement
      mapped.hormone_replacement_therapy = patientPersonalFamilyInfo.hormonalReplacement?.yesNo ? "Yes" : "No";
      mapped.hormone_replacement_therapy_sub = patientPersonalFamilyInfo.hormonalReplacement?.describe || "";

      // Map gynecological symptoms
      mapped.symptomatic_problems_menopause_other = patientPersonalFamilyInfo.gynSymptoms || [];

      // Map other tests
      mapped.other_test_procedures = patientPersonalFamilyInfo.otherTest || "";
      // Map hormonal birth control
      if (patientPersonalFamilyInfo.hormonalBirthControlType?.name) {
        const bcType = patientPersonalFamilyInfo.hormonalBirthControlType.name;

        if (["Birth control pills", "Patch", "Nuva ring"].includes(bcType)) {
          mapped.hormonal_birthcontrol = bcType;
        } else {
          mapped.hormonal_birthcontrol = "Other";
          mapped.hormonal_birthcontrol_other = bcType;
        }

        mapped.hormonal_birthcontrol_duration =
          patientPersonalFamilyInfo.hormonalBirthControlType.level || "";
      } else {
        mapped.hormonal_birthcontrol = "";
        mapped.hormonal_birthcontrol_other = patientPersonalFamilyInfo.otherHormonalBirthControl || "";
        mapped.hormonal_birthcontrol_duration = "";
      }

      console.log('Mapped answers:', mapped);
      setAnswers(mapped);
    }
  }, [patientPersonalFamilyInfo]);

  // Derive visibleQuestions from the full `questions` list and answers.
  // If hormonal_birthcontrol === "No", remove the next 2 questions after it.
  // If pregnancies is not checked, hide pregnancy_problems question.
  const visibleQuestions = useMemo(() => {
    const v = [...questions];
    
    // Remove hormonal birth control related questions if hormonal_birthcontrol === "No"
    const hormonalIdx = v.findIndex(q => q.name === "hormonal_birthcontrol");
    if (hormonalIdx !== -1 && answers.hormonal_birthcontrol === "No") {
      v.splice(hormonalIdx + 1, 2);
    }
    
    // Remove pregnancy_problems question if pregnancies is not checked
    const pregnancyProblemsIdx = v.findIndex(q => q.name === "pregnancy_problems");
    if (pregnancyProblemsIdx !== -1 && !answers["pregnancies"]) {
      v.splice(pregnancyProblemsIdx, 1);
    }
    
    return v;
  }, [answers]);

  const totalQuestions = visibleQuestions.length;

  // If currentQuestionIndex becomes out of bounds after visibleQuestions shrinks, clamp it.
  useEffect(() => {
    if (currentQuestionIndex > totalQuestions - 1) {
      setCurrentQuestionIndex(Math.max(0, totalQuestions - 1));
    }
  }, [totalQuestions, currentQuestionIndex]);

  const validateQuestion = () => {
    const question = visibleQuestions[currentQuestionIndex];
    if (!question) return true;

    if (question.question === "(Check if applicable)" || question.name === "other_test_procedures") {
      return true;
    }
  
    switch (question.type) {
      case "radio": {
        if (answers[question.name] === undefined || answers[question.name] === null || answers[question.name] === "") {
          console.log(`Validation failed: '${question.name}' radio question not answered.`);
          return false;
        }
        return true;
      }
      case "checkbox_with_select":
        for (const option of question.options) {
          const checkboxChecked = answers[option.name] || false;
          const selectName = option.selectName;
  
          if (checkboxChecked && selectName) {
            const selectValue = answers[selectName];
            if (selectValue === undefined || selectValue === "") {
              console.log(`Validation Failed: Checkbox ${option.name} is checked, but select ${selectName} is empty.`);
              return false;
            }
          }
        }
        console.log("Validation Passed: All checked checkboxes have filled selects.");
        return true;
  
      case "long_radio":
        if (answers[question.name] === undefined) {
          return false;
        }
  
        if (answers[question.name] === "Yes") {
          if (!question.subQuestions) return true;
  
          for (const subQuestion of question.subQuestions) {
            if (answers[subQuestion.name] === undefined || answers[subQuestion.name] === "") {
              console.log(
                `Validation Failed: Sub-question ${subQuestion.name} is not answered.`
              );
              return false;
            }
          }
        }
        return true;
  
        case "checkbox":
          if (!answers[question.name] || answers[question.name].length === 0) {
            return false;
          }
    
          const requiresOtherInput =
            answers[question.name].includes("Other") ||
            answers[question.name].includes("Sexually transmitted disease (describe)");
    
          if (requiresOtherInput) {
            const otherInputName = `${question.name}_other`;
            if (!answers[otherInputName] || answers[otherInputName] === "") {
              console.log("Validation Failed: Other/STD is checked, but input field is empty.");
              return false;
            }
          }
    
  
        return true;
  
      case "unit_toggle": {
        if (answers.weight_unit_na) return true;
        // For weight inputs, at least one weight should be provided
        const hasSmallestWeight = answers.smallest_baby_weight !== undefined && 
                                answers.smallest_baby_weight !== "" && 
                                !isNaN(answers.smallest_baby_weight) && 
                                parseFloat(answers.smallest_baby_weight) >= 0;
        
        const hasLargestWeight = answers.largest_baby_weight !== undefined && 
                               answers.largest_baby_weight !== "" && 
                               !isNaN(answers.largest_baby_weight) && 
                               parseFloat(answers.largest_baby_weight) >= 0;
        
        // If either weight is provided, validate that it's a reasonable value
        if (hasSmallestWeight) {
          const weight = parseFloat(answers.smallest_baby_weight);
          const isMetric = unit === "Metric";
          // Valid range: 0.5-15 kg or 1-33 lbs
          if ((isMetric && (weight < 0.5 || weight > 15)) || 
              (!isMetric && (weight < 1 || weight > 33))) {
            message.error("Please enter a valid weight for smallest baby");
            return false;
          }
        }
        
        if (hasLargestWeight) {
          const weight = parseFloat(answers.largest_baby_weight);
          const isMetric = unit === "Metric";
          // Valid range: 0.5-15 kg or 1-33 lbs
          if ((isMetric && (weight < 0.5 || weight > 15)) || 
              (!isMetric && (weight < 1 || weight > 33))) {
            message.error("Please enter a valid weight for largest baby");
            return false;
          }
        }
        
        // If both weights are provided, validate that largest is not smaller than smallest
        if (hasSmallestWeight && hasLargestWeight) {
          const smallest = parseFloat(answers.smallest_baby_weight);
          const largest = parseFloat(answers.largest_baby_weight);
          if (largest < smallest) {
            message.error("Largest baby weight cannot be smaller than smallest baby weight");
            return false;
          }
        }
        
        // At least one weight should be provided
        return hasSmallestWeight || hasLargestWeight;
      }
      
      default:
        return answers[question.name] !== undefined && answers[question.name] !== "";
    }
  };
  
  const handleExit = () => {
    navigate("/assessment");
  };
  const handleSave = () => {
    if (!validateQuestion()) {
      message.error("Please answer the current question before saving.");
      return;
    }
    localStorage.setItem("currentQuestionIndex7", 0);
    localStorage.setItem("answers", JSON.stringify(answers));
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };
  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleChange = (value, name) => {
    // Find the question object by name
    const question = questions.find(q => q.name === name);
    const updatedAnswers = { ...answers };

    if (question && (question.type === "radio" || question.type === "long_radio")) {
      // For radio buttons, clear all related fields when selection changes
      updatedAnswers[name] = value;
      
      // Clear any _other fields
      delete updatedAnswers[`${name}_other`];
      
      // Clear subquestion answers if they exist
      if (question.subQuestions) {
        question.subQuestions.forEach(subQ => {
          delete updatedAnswers[subQ.name];
          delete updatedAnswers[`${subQ.name}_other`];
        });
      }
      
      // Special logic for "Use of hormonal birth control"
      if (name === "hormonal_birthcontrol") {
        if (value === "No") {
          // Clear the next two related answers (their values and any subquestion values)
          const qIndex = questions.findIndex(q => q.name === name);
          if (qIndex !== -1) {
            const next1Name = questions[qIndex + 1]?.name;
            const next2Name = questions[qIndex + 2]?.name;
            if (next1Name) {
              delete updatedAnswers[next1Name];
              const q1Obj = questions.find(q => q.name === next1Name);
              if (q1Obj && q1Obj.subQuestions) {
                q1Obj.subQuestions.forEach(sq => {
                  delete updatedAnswers[sq.name];
                  delete updatedAnswers[`${sq.name}_other`];
                });
              }
            }
            if (next2Name) {
              delete updatedAnswers[next2Name];
              const q2Obj = questions.find(q => q.name === next2Name);
              if (q2Obj && q2Obj.subQuestions) {
                q2Obj.subQuestions.forEach(sq => {
                  delete updatedAnswers[sq.name];
                  delete updatedAnswers[`${sq.name}_other`];
                });
              }
            }
          }
        }
      }

      // Special handling for specific questions
      if (name === "use_of_contraception") {
        delete updatedAnswers.use_of_contraception_sub;
      } else if (name === "is_menopause") {
        delete updatedAnswers.age_at_last_period;
      } else if (name === "surgical_menopause") {
        delete updatedAnswers.surgical_menopause_detail;
      } else if (name === "hormone_replacement_therapy") {
        delete updatedAnswers.hormone_replacement_therapy_sub;
      } else if (name === "pregnancy_problems") {
        delete updatedAnswers.pregnancy_problems_sub;
      } else if (name === "premenstrual_problems") {
        delete updatedAnswers.premenstrual_problems_describe;
      } else if (name === "other_premenstrual_problems") {
        delete updatedAnswers.other_hormonal_problems_history;
      } else if (name === "hormonal_birthcontrol") {
        delete updatedAnswers.hormonal_birthcontrol_often;
      } else if (name === "other_hormonal_problems") {
        delete updatedAnswers.any_hormonal_problems_bc;
      }
    } else {
      updatedAnswers[name] = value;
    }

    setAnswers(updatedAnswers);
  };

  const handleSubmit = async () => {
    if (!validateQuestion()) {
      message.error("Please answer the current question before Submitting.");
      return;
    }
    

    // Prepare obstetric history data
    const obstetricCategories = [
      "Pregnancies",
      "Miscarriages",
      "Abortions",
      "Living children",
      "Vaginal deliveries",
      "Caesarean",
      "Term births",
      "Premature birth",
      "None of the above"
    ];
    
    const obstetricHistory = obstetricCategories.map(category => ({
      name: category,
      level: answers[`${category.toLowerCase().replace(/\s+/g, "_")}_select`] || 0
    }));

    // Prepare weight data and handle unit conversion if needed
    const smallestWeight = answers.smallest_baby_weight ? parseFloat(answers.smallest_baby_weight) : 0;
    const largestWeight = answers.largest_baby_weight ? parseFloat(answers.largest_baby_weight) : 0;
    
    // Convert weights if in Imperial units
    const weightMultiplier = unit === "Imperial" ? 0.45359237 : 1; // Convert lbs to kg if Imperial
    //const weightUnitNA = answers.weight_unit_na === true;
    const apiPayload = {
      obstetricHistory: obstetricHistory,
      weightChild: {
        metricImperialScale: unit === "Metric",
        weightSmallest: smallestWeight * weightMultiplier,
        weightLargest: largestWeight * weightMultiplier
      },
      problemsAfterPregnancy: answers.pregnancy_problems === "Yes",
      problemsAfterPregnancyExplain: answers.pregnancy_problems_sub || "",
      ageStartMenstrual: answers.age_of_period || 0,
      startDateLastMenstrual: answers.date_of_last_period || "string",
      lenghtOfCycle: answers.length_of_cycle || 0,
      timeBtwCycles: answers.times_between_of_cycle || 0,
      cramping: answers.cramping === "Yes",
      painInPeriod: answers.pain === "Yes",
      everHadPreMenstrualProblems: {
          yesNo: answers.premenstrual_problems === "Yes",
          describe: answers.premenstrual_problems_describe || "",
      },
      otherMenstrualProblems: {
          yesNo: answers.other_premenstrual_problems === "Yes",
          describe: answers.other_hormonal_problems_history || "",
      },
    otherHormonalBirthControl: answers.hormonal_birthcontrol_other || "",
    hormonalBirthControlType: {
      level: answers.hormonal_birthcontrol_duration || "",
      name:
        answers.hormonal_birthcontrol === "Other"
          ? answers.hormonal_birthcontrol_other || ""
          : answers.hormonal_birthcontrol || "",
    },
    
      problemsWithHormonalBirthControl: {
          yesNo: answers.other_hormonal_problems === "Yes",
          describe: answers.any_hormonal_problems_bc || "",
      },
      useContraception: {
        yesNo: answers.use_of_contraception === "Yes",
        describe:
          answers.use_of_contraception_sub === "Other"
            ? answers.use_of_contraception_sub_other || ""
            : answers.use_of_contraception_sub || "",
      },
      otherContraceptions:
        answers.use_of_contraception_sub === "Other"
          ? answers.use_of_contraception_sub_other || ""
          : "",
      inMenopause: {
        yesNo: answers.is_menopause === "Yes",
        level: answers.age_at_last_period || 0,
      },

      surgicalMenopause: {
        yesNo: answers.surgical_menopause === "Yes",
        describe: answers.surgical_menopause_detail || "",
    },
      symptomicProblems: answers.symptomatic_problems_menopause_history || [],
      hormonalReplacement: {
          yesNo: answers.hormone_replacement_therapy === "Yes",
          describe: answers.hormone_replacement_therapy_sub || "",
      },
      gynSymptoms: answers.symptomatic_problems_menopause_other || [],
      gynScreeningLastPapTest: {
          date: "", // Adjust if applicable
          value: "", // Adjust if applicable
      },
      gynScreeningLastMammo: {
          date: "", // Adjust if applicable
          value: "", // Adjust if applicable
      },
      gynScreeningLastBoneDesity: {
          date: "", // Adjust if applicable
          value: "", // Adjust if applicable
      },
      otherTest: answers.other_test_procedures || "none",
  };

  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
  const token = userInfo.obj?.token || "";
console.log("apiPayload--", apiPayload);
  try {
    const response = await fetch(
      `${baseUrl}Patient/AddPersonalFamily`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(apiPayload),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to submit data");
    }

    dispatch(completeCard("/questionnaire/7"));
    localStorage.setItem("currentQuestionIndex7", 0);
    localStorage.setItem("answers", JSON.stringify(answers));
    navigate("/assessment");
  } catch (error) {
    console.error("Error submitting the form:", error);
    message.error("Failed to submit the form. Please try again.");
  }
};

  
  const renderSubQuestions = (subQuestions) => {
    return subQuestions.map((subQuestion, index) => (
      <div key={index} style={{ marginTop: "20px" }}>
        <p style={{color:"#000"}}>{subQuestion.type !== "text" && subQuestion.question}</p>
        {subQuestion.type === "text" && (
          <Input
            placeholder={subQuestion.question}
            value={answers[subQuestion.name] || ""}
            onChange={(e) => handleChange(e.target.value, subQuestion.name)}
            className="input_questtionnaire"
            style={{ width: "100%", maxWidth: "640px" }}
          />
        )}
        {subQuestion.type === "inputNumber" && (
          <InputNumber
            name={subQuestion.name}
            value={answers[subQuestion.name] || 0}
            onChange={(value) => handleChange(value, subQuestion.name)}
            className="input_questtionnaire"
          />
        )}

        {subQuestion.type === "select" && (
          <Select
            className="select_questtionnaire"
            name={subQuestion.name}
            value={answers[subQuestion.name] || ""}
            onChange={(value) => handleChange(value, subQuestion.name)}
          >
            {subQuestion.options.map((option, index) => (
              <Option key={index} value={option}>
                {option}
              </Option>
            ))}
          </Select>)}

        {subQuestion.type === "radio" && (
          <Radio.Group
            name={subQuestion.name}
            onChange={(e) => handleChange(e.target.value, subQuestion.name)}
            value={answers[subQuestion.name]}
            style={{ width: "100%" }}
          >
            {subQuestion.options.map((option, idx) => (
              <Radio key={idx} value={option} style={{ display: "block", marginBottom: "10px" }}>
                {option === "Other" ? (
                  <>
                    {option}
                    {answers[subQuestion.name] === "Other" && (
                      <>
                        <br />
                        <Input
                          className="input_questtionnaire"
                          placeholder="Please specify"
                          value={answers[`${subQuestion.name}_other`] || ""}
                          onChange={(e) =>
                            handleChange(e.target.value, `${subQuestion.name}_other`)
                          }
                        />
                      </>
                    )}
                  </>
                ) : (
                  option
                )}
              </Radio>
            ))}
  </Radio.Group>
)}


      </div>
    ));
  };

  const handleSelectCheckChange = (checked, name, selectName, options) => {
    setAnswers(prevAnswers => {
      const updatedAnswers = { ...prevAnswers };
      if (name === "obstetricHistory_none" && checked) {
        // Uncheck all others
        options.forEach(opt => {
          updatedAnswers[opt.name] = false;
          if (opt.selectName) {
            updatedAnswers[opt.selectName] = undefined;
          }
        });
        updatedAnswers["obstetricHistory_none"] = true;
        // Set weight_unit_na to true when N/A is selected
        updatedAnswers.weight_unit_na = true;
      } else {
        updatedAnswers[name] = checked;
        if (!checked && selectName) {
          updatedAnswers[selectName] = undefined;
        }
        // If any other checkbox is checked, uncheck "none"
        if (checked && updatedAnswers["obstetricHistory_none"]) {
          updatedAnswers["obstetricHistory_none"] = false;
        }
        
        // If pregnancies is unchecked, clear other checkboxes if pregnancies has a value
        if (name === "pregnancies" && !checked) {
          options.forEach(opt => {
            if (opt.name !== "pregnancies" && opt.name !== "obstetricHistory_none") {
              updatedAnswers[opt.name] = false;
              if (opt.selectName) {
                updatedAnswers[opt.selectName] = undefined;
              }
            }
          });
          // Set weight_unit_na to true when pregnancies is unchecked
          updatedAnswers.weight_unit_na = true;
          updatedAnswers.smallest_baby_weight = "";
          updatedAnswers.largest_baby_weight = "";
        }
        
        // If pregnancies is checked, enable weight_unit (set weight_unit_na to false)
        if (name === "pregnancies" && checked) {
          updatedAnswers.weight_unit_na = false;
        }
      }
      return updatedAnswers;
    });
  };

  
  const handleSelectChange = (value, selectName) => {
    setAnswers((prevAnswers) => {
      const updatedAnswers = { ...prevAnswers };
      updatedAnswers[selectName] = value;
      
      // If pregnancies_select gets a value, clear other checkboxes and enable weight_unit
      if (selectName === "pregnancies_select" && value !== undefined && value !== "") {
        const options = questions.find(q => q.name === "obstetricHistory")?.options || [];
        options.forEach(opt => {
          if (opt.name !== "pregnancies" && opt.name !== "obstetricHistory_none") {
            updatedAnswers[opt.name] = false;
            if (opt.selectName) {
              updatedAnswers[opt.selectName] = undefined;
            }
          }
        });
        // Enable weight_unit by setting weight_unit_na to false
        updatedAnswers.weight_unit_na = false;
      } else if (selectName === "pregnancies_select" && (value === undefined || value === "")) {
        // If pregnancies_select is cleared, disable weight_unit
        updatedAnswers.weight_unit_na = true;
        updatedAnswers.smallest_baby_weight = "";
        updatedAnswers.largest_baby_weight = "";
      }
      
      return updatedAnswers;
    });
  };
  const renderInput = (question) => {
    switch (question.type) {
      case "date":
        return (
          <DatePicker
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            value={answers[question.name] ? dayjs(answers[question.name]) : null}
            format="YYYY-MM-DD"
            style={{
              width: isMobile ? "100%" : "50%",
              height: "42px",
              borderColor: "#ccc"
            }}
            onChange={(date, dateString) => handleChange(dateString, question.name)}
          />
        );
      case "select":
        return (
          <div className="select_questionnaire-wrapper">
            <Select
              className="select_questionnaire"
              name={question.name}
              value={answers?.[question.name] || ""}
              onChange={(value) => {
                // Special handling for length_of_cycle
                if (question.name === "length_of_cycle") {
                  let apiValue = value;
                  if (value === "Under 20") apiValue = 20;
                  if (value === "Above 34") apiValue = 35;
                  handleChange(apiValue, question.name);
                } else {
                  handleChange(value, question.name);
                }
              }}
            >
              {question.options?.map((option, index) => (
                <Option key={index} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
            {(question.name === "length_of_cycle" || question.name === "times_between_of_cycle") ? (
              <span style={{color:"#000"}} className="select-suffix"> Days</span>
            ) : (
              ""
            )}
          </div>
        );
      case "radio":
        return (
          <div style={{ flexDirection: "column" }}>
            <Radio.Group
              name={question.name}
              onChange={(e) => handleChange(e.target.value, question.name)}
              value={answers[question.name]}
              style={{ width: "100%" }}
            >
              {question.options.map((option, index) => (
                <Radio
                  key={index}
                  value={option}
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  {option}
                </Radio>
              ))}
            </Radio.Group>

            {/* Special handling only for "hormonal_birthcontrol" */}
            {question.name === "hormonal_birthcontrol" && (
              <>
                {/* Show "Other" text input only when Other is selected */}
                {answers[question.name] === "Other" && (
                  <Input
                    placeholder="If yes, please describe"
                    value={answers["hormonal_birthcontrol_other"]}
                    onChange={(e) =>
                      setAnswers({
                        ...answers,
                        hormonal_birthcontrol_other: e.target.value,
                      })
                    }
                    style={{ marginTop: 10, width:"40%" }}
                  />
                )}
                <div><label>How Long?</label></div>
                <Input
                  placeholder="How long?"
                  value={answers["hormonal_birthcontrol_duration"]}
                  onChange={(e) =>
                    setAnswers({
                      ...answers,
                      hormonal_birthcontrol_duration: e.target.value,
                    })
                  }
                  style={{ marginTop: 10, width:"40%" }}
                />

              </>
            )}
          </div>
        );
        
      case "unit_toggle":
        return (
          <div>
            {/* Metric / Imperial toggle + inputs */}
            <div
              style={{
                opacity: answers.weight_unit_na ? 0.5 : 1,
                pointerEvents: answers.weight_unit_na ? "none" : "auto",
              }}
            >
              {/* switch */}
              <div
                style={{
                  background: "#C2E6F8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px 16px",
                  color: "#000",
                  marginBottom: 20,
                  borderRadius: 10,
                  width: isMobile ? "100%" : "200px",
                }}
              >
                <span style={{ marginRight: 10 }}>Metric</span>
                <Switch
                  checked={unit === "Imperial"}
                  onChange={(checked) => setUnit(checked ? "Imperial" : "Metric")}
                />
                <span style={{ marginLeft: 10 }}>Imperial</span>
              </div>
        
              {/* inputs */}
              {question.subQuestions.map((sub, idx) => (
                <div key={idx} style={{ marginBottom: 15 }}>
                  <div style={{ marginBottom: 5 }}>{sub.question}</div>
                  <Input
                    type="number"
                    min={0}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // block negative sign and exponential notation
                      }
                    }}
                    style={{ width: isMobile ? "100%" : "200px" }}
                    value={answers[sub.name] || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || parseFloat(val) >= 0) {
                        handleChange(val, sub.name);
                      }
                    }}
                    suffix={unit === "Metric" ? "kg" : "lbs"}
                  />
                </div>
              ))}

            </div>
        
            {/* N / A CHECKBOX at bottom */}
            <Checkbox
              style={{ marginTop: 10 }}
              checked={answers.weight_unit_na || false}
              onChange={(e) => {
                const checked = e.target.checked;
                handleChange(checked, "weight_unit_na");
        
                if (checked) {
                  handleChange("", "smallest_baby_weight");
                  handleChange("", "largest_baby_weight");
                }
              }}
            >
              N/A
            </Checkbox>
          </div>
        );

      case "checkbox_with_number":
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Checkbox
              onChange={(e) =>
                handleChange(e.target.checked, `${question.name}_checked`)
              }
              checked={answers[`${question.name}_checked`] || false}
            >
              {question.question}
            </Checkbox>
            {answers[`${question.name}_checked`] && (
              <Input
                type="number"
                className="input_questionnaire"
                placeholder="Enter value"
                onChange={(e) => handleChange(e.target.value, question.name)}
                value={answers[question.name] || ""}
                style={{ marginLeft: "10px", width: "100px" }}
                min={0}
              />
            )}
            {answers[`${question.name}_checked`] && (
              <span style={{ marginLeft: "10px" }}>
                {unit === "Metric" ? "kg" : "lbs"}
              </span>
            )}
          </div>
        );
      case "checkbox_with_select":
        return (
          <div
            style={{
              marginTop: "20px",
              display: "grid",
              gridTemplateColumns: "1fr 2fr",
              gap: "10px",
            }}
          >
            {question.options.map((option, idx) => {
              // Check if pregnancies is checked and has a value
              const pregnanciesChecked = answers["pregnancies"] || false;
              const pregnanciesHasValue = answers["pregnancies_select"] !== undefined && answers["pregnancies_select"] !== "";
              
              // Disable other options if pregnancies is checked and has a value
              const isOtherOption = option.name !== "pregnancies" && option.name !== "obstetricHistory_none";
              const isDisabled = isOtherOption && pregnanciesChecked && pregnanciesHasValue;

              return (
                <React.Fragment key={idx}>
                  <div style={{ display: "flex", alignItems: "center", opacity: isDisabled ? 0.5 : 1 }}>
                    <Checkbox
                      onChange={(e) =>
                        handleSelectCheckChange(
                          e.target.checked,
                          option.name,
                          option.selectName,
                          question.options,
                        )
                      }
                      checked={answers[option.name] || false}
                      disabled={isDisabled}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                  {option.selectName && (
                    <div style={{ display: "flex", alignItems: "center", width: isMobile ? "100%" : "50%", opacity: isDisabled ? 0.5 : 1 }}>
                      <Select
                        name={option.selectName}
                        value={answers[option.selectName] || undefined}
                        onChange={(value) => handleSelectChange(value, option.selectName)} // Use the new handler
                        style={{ width: "100%" }}
                        disabled={!answers[option.name] || isDisabled}
                      >
                        {option.selectOptions.map((selectOption, idx) => (
                          <Option key={idx} value={selectOption}>
                            {selectOption}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  )}

                </React.Fragment>
              );
            })}
          </div>
        );

      case "radiowithselect":
        return (
          <Radio.Group
            name={question.name}
            onChange={(e) => handleChange(e.target.value, question.name)}
            value={answers[question.name]}
            style={{ width: "100%" }}
          >
            {question.options.map((option, index) => (
              <Radio
                key={index}
                value={option}
                style={{ display: "block", marginBottom: "10px" }}
              >
                {option}
              </Radio>
            ))}
            {answers[question.name] === "No" && (
              <Select
                placeholder="Please specify"
                value={answers[`${question.name}_detail`] || ""}
                onChange={(value) =>
                  handleChange(value, `${question.name}_detail`)
                }
                style={{ width: "100%", marginTop: "10px" }}
              >
                <Option value="1"> 1</Option>
                <Option value="2"> 2</Option>
                <Option value="3"> 3</Option>
              </Select>
            )}
          </Radio.Group>
        );

      case "rating_scale":
        return (
          <div>
            <Button
              type="primary"
              style={{ background: "#335CAD", padding: 20 }}
            >
              {question.sub}
            </Button>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "10px",
              }}
            >
              {[...Array(10)].map((_, i) => (
                <div
                  key={i}
                  onClick={() => handleChange(i + 1, question.name)}
                  style={{
                    width: "30px",
                    height: "30px",
                    border: "1px solid #00ADEF",
                    display: "flex",
                    padding: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    borderRadius: 5,
                    background:
                      answers[question.name] === i + 1
                        ? "#00ADEF"
                        : "transparent",
                    color:
                      answers[question.name] === i + 1 ? "#fff" : "#00ADEF",
                  }}
                >
                  {i + 1}
                </div>
              ))}
            </div>
          </div>
        );
      case "long_textarea":
        return (
          <div style={{ flexDirection: "column" }}>
            <Input.TextArea
              className="input_questtionnaire"
              name={question.name}
              value={answers[question.name] || ""}
              onChange={(e) => handleChange(e.target.value, question.name)}
              rows={4}
              style={{ marginTop: "10px" }} // Ensure there's some spacing between the button and textarea
            />
          </div>
        );
      case "long_select":
        return (
          <div style={{ flexDirection: "column" }}>
            <Button
              type="primary"
              style={{ background: "#335CAD", padding: 20 }}
            >
              {question.sub}
            </Button>
            <br />
            <Select
              className="select_questtionnaire"
              name={question.name}
              value={answers[question.name] || ""}
              onChange={(value) => handleChange(value, question.name)}
              style={{ marginTop: "10px", width: "100%" }}
            >
              {question.selectOptions.map((option, index) => (
                <Option key={index} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
        );
        case "checkbox": {
          const isNASelected =
            Array.isArray(answers[question.name]) &&
            answers[question.name].includes("N/A");
        
          return (
            <Checkbox.Group
              name={question.name}
              onChange={(checkedValues) => {
                let updated = checkedValues;
                if (checkedValues.includes("N/A")) {
                  updated = ["N/A"];
                } else {
                  updated = checkedValues.filter((v) => v !== "N/A");
                }
                handleChange(updated, question.name);
              }}
              value={answers[question.name] || []}
              className="checkbox-group"
            >
              {question.options.map((option, index) => (
                <Checkbox
                  key={index}
                  value={option}
                  className="checkbox-item"
                  disabled={option !== "N/A" && isNASelected}
                >
                  {option === "Other" ||
                  option === "Sexually transmitted disease (describe)" ? (
                    <>
                      {option}
                      {(answers[question.name]?.includes("Other") ||
                        answers[question.name]?.includes(
                          "Sexually transmitted disease (describe)"
                        )) && !isNASelected && (
                        <>
                          <br />
                          <Input
                            className="input_questtionnaire"
                            placeholder="Please specify"
                            value={answers[`${question.name}_other`] || ""}
                            onChange={(e) =>
                              handleChange(e.target.value, `${question.name}_other`)
                            }
                          />
                        </>
                      )}
                    </>
                  ) : (
                    option
                  )}
                </Checkbox>
              ))}
            </Checkbox.Group>
          );
        }
        
      
        case "long_radio":
        return (
          <div style={{ flexDirection: "column" }}>
            <Radio.Group
              name={question.name}
              onChange={(e) => handleChange(e.target.value, question.name)}
              value={answers[question.name]}
              style={{ width: "100%" }}
            >
              {question.options.map((option, index) => (
                <Radio
                  key={index}
                  value={option}
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  <span style={{ verticalAlign: 'text-bottom' }}>{option}</span>
                </Radio>
              ))}
            </Radio.Group>
            {answers[question.name] === "Yes" &&
              renderSubQuestions(question.subQuestions)}
          </div>
        );
      
        case "date_radio":
        return (
          <div key={question.name} style={{ marginBottom: "20px" }}>
            <Button
              type="primary"
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                background: "#335CAD",
                padding: 10,
              }}
            >
              {question.buttonText}
            </Button>
            <div style={{ marginBottom: "10px" }}>
              <label>Date:</label>
              <br />
              <Input
                type="date"
                className="input_questionnaire"
                name={question.dateName}
                value={answers[question.dateName] || ""}
                onChange={(e) =>
                  handleChange(e.target.value, question.dateName)
                }
                style={{ width: "200px" }}
              />
            </div>
            {question.radioOptions.map((option, index) => (
              <div key={index} style={{ marginBottom: "5px" }}>
                <Radio
                  name={question.radioName}
                  value={option.value}
                  checked={answers[question.radioName] === option.value}
                  onChange={(e) =>
                    handleChange(e.target.value, question.radioName)
                  }
                >
                  {option.label}
                </Radio>
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };
  const currentQuestion = visibleQuestions[currentQuestionIndex] || {};
  const label = (
    <span>
      {
        currentQuestion.name !== "symptomatic_problems_menopause_other" && currentQuestion.name !== "other_test_procedures"? <span style={{ color: "red" }}>* </span>: undefined
      }
    </span>
  );

  const progressColor =
    currentQuestionIndex === totalQuestions - 1 ? "#01ACEE" : "#C2E6F8";
  const progressPercentage =
    ((currentQuestionIndex + 1) / totalQuestions) * 100;

  return (
    <Row gutter={16} style={{ padding: "0 5%" }}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <FormWrapper name="FEMALE INTAKE QUESTIONNAIRE" />
        <Progress
          percent={Math.round(progressPercentage)}
          strokeColor={progressColor}
        />
        <h3 style={{ margin: "20px 0", color: "#F2AA93" }}>
        
          {currentQuestion.title}
        </h3>

        <h3 style={{ margin: "20px 0", color: "#000", fontWeight: "600", fontSize: "15px" }}>
        {label} {currentQuestion.question}
        </h3>
        {renderInput(currentQuestion)}

        <div
          style={{ margin: "20px 0", marginTop: isMobile ? 50 : 200 }}
          className="button_group"
        >
          {isMobile ? (
            <Button
              onClick={handlePrevious}
              className="back-button"
              disabled={currentQuestionIndex === 0}
            >
              {backBtnTxt}
            </Button>
          ) : (
            <Button onClick={handleExit} className="previous-button">
              {exitBtnTxt}
            </Button>
          )}
          {currentQuestionIndex === totalQuestions - 1 ? (
            <>
              <Button
                type="primary"
                className="submit-button"
                onClick={handleSubmit}
              >
                {submitBtn}
              </Button>
              {isMobile ? (
                <Button onClick={handleExit} className="previous-button">
                  {exitBtnTxt}
                </Button>
              ) : (
                <Button
                  onClick={handlePrevious}
                  className="back-button"
                  disabled={currentQuestionIndex === 0}
                >
                  {backBtnTxt}
                </Button>
              )}
            </>
          ) : (
            <span className="save_and_exit_group_btn">
              <Button
                type="primary"
                className="save-button"
                onClick={handleSave}
              >
                {saveAndContinueBtn}
              </Button>
              {isMobile ? (
                <Button onClick={handleExit} className="previous-button">
                  {exitBtnTxt}
                </Button>
              ) : (
                <Button
                  onClick={handlePrevious}
                  className="back-button"
                  disabled={currentQuestionIndex === 0}
                >
                  {backBtnTxt}
                </Button>
              )}
            </span>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PersonalAndFamilyHistory;
